// Conceptually equivalent to a Navigation Bar
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { compose, withProps } from 'recompose';

import { Container, Step, Icon } from 'semantic-ui-react';
import styles from './styles.module.scss';

const ROUTES = {
  city: '/', // keyname, pathname
  levers: '/levers',
  results: '/results',
}
const ROUTE_LIST = Object.entries(ROUTES);

const StepBar = (props) => {
  const { pageStatus } = props;
  return (
  <Container className={styles.stepBarContainer} textAlign='center'>
    <Step.Group ordered>
        <Step {...pageStatus.city}>
          <Link to="/">
          <Icon name='truck' />
          <Step.Content>
            <Step.Title>City Data</Step.Title>
            {/* <Step.Description>Details about your city</Step.Description> */}
          </Step.Content>
          </Link>
        </Step>

        <Step {...pageStatus.levers} >
          <Link to="/levers">
            <Icon name='calculator' />
            <Step.Content>
              <Step.Title>Levers</Step.Title>
              {/* <Step.Description>Build your own scenario</Step.Description> */}
            </Step.Content>
           </Link>
        </Step>
      <Step {...pageStatus.results}>
        <Link to="/results">
        <Icon name='chart line' />
        <Step.Content>
          <Step.Title>Results</Step.Title>
        </Step.Content>
        </Link>
      </Step>

    </Step.Group>
  </Container>);
}


const withPageStatus = (props) => {
  const { pathname } = props.location; // from react router
  const pageStatus = {
    city: {},
    levers: {},
    results: {}
  }
  ROUTE_LIST.forEach(([keyname, path], index) => {
    const isMatchPage = path === pathname;
    if (isMatchPage) {
      pageStatus[keyname].active = true;
    }
    // Knock out pages you haven't filled out yet - Disabled til we confirm it's wanted
    // const indexOfMatchingPage = ROUTE_LIST.findIndex((item) => item[1] === pathname);
    // if (index > indexOfMatchingPage) {
    //   // pageStatus[keyname].disabled = true;
    // }
  })

  return pageStatus;
}
const enhancers = compose(
  withRouter,
  withProps(props => ({
    pageStatus: withPageStatus(props)
  })),
)



export default enhancers(StepBar);



// WEBPACK FOOTER //
// ./src/components/stepBar/index.js